<template>
  <div v-if="isVisible" class="theme-loading-overlay">
    <div class="theme-loading-content">
      <div class="theme-loading-spinner"></div>
      <div class="theme-loading-text">{{ loadingText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThemeLoadingOverlay',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'Switching theme...'
    }
  }
};
</script>

<style scoped>
.theme-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.theme-loading-overlay.show {
  opacity: 1;
}

.theme-loading-content {
  text-align: center;
  color: white;
  padding: 20px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.theme-loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: theme-spin 1s linear infinite;
  margin: 0 auto 16px;
}

.theme-loading-text {
  font-size: 16px;
  font-weight: 500;
  color: white;
}

@keyframes theme-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Dark mode loading overlay */
.dark .theme-loading-overlay {
  background: rgba(16, 13, 24, 0.9);
}

.dark .theme-loading-content {
  background: rgba(35, 39, 46, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.dark .theme-loading-text {
  color: #f3f5f7;
}
</style>
